import React from "react";
import { useState, useEffect } from "react";
import {
  collection,
  documentId,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  where
} from "firebase/firestore";
import { db } from "../../../firebase";
import { useRef } from "react";
import {
  convertTomm,
  detectChanges,
  isNotExists,
  roundOff,
  roundOffTwo,
  standardDeviation
} from "../../../utils/common_handlers";
import { useUsersData } from "../../../providers/UsersDataProvider";
import { Card, CardBody, Col, Container, NavLink, Row } from "shards-react";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useHistory, NavLink as RouteNavLink } from "react-router-dom";

let snapShotListeners = [];
const MonitoringUsers = props => {
  const { user } = props;
  const history = useHistory();
  const { remoteConfigData } = useUsersData();
  const [loading, setLoading] = useState(false);
  const [mUserIds, setMUserIds] = useState([]);
  const [mUserList, setMUserList] = useState([]);
  const [filteredMUsers, setFilteredMUsers] = useState(mUserList);
  const [filterText, setFilterText] = useState("");
  const mUserListRef = useRef(mUserList);

  useEffect(() => {
    if (user && user.MonitoringUsers && user.MonitoringUsers.length > 0) {
      setMUserIds([]);
      for (let i = 0; i < user.MonitoringUsers.length; i++) {
        if (user.MonitoringUsers[i].UserApprovedMonitoring === true) {
          setMUserIds(prev => [...prev, user.MonitoringUsers[i].UserId]);
        }
      }
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    const collRef = collection(db, "UserData");
    setMUserList([]);
    if (mUserIds.length > 0) {
      let ids = [];
      for (let i = 0; i < mUserIds.length; i++) {
        if (ids.length <= 10) {
          ids.push(mUserIds[i]);
        }
        if (ids.length === 10 || i === mUserIds.length - 1) {
          const queryUsers = query(collRef, where(documentId(), "in", ids));
          const snapSubscription = onSnapshot(queryUsers, data => {
            if (data.size) {
              setLoading(false);
            }
            processData(data);
          });
          snapShotListeners.push(snapSubscription);
          ids = [];
        }
      }
    } else {
      setLoading(false);
    }
    return () => {
      snapShotListeners.forEach(unsub => {
        unsub();
      });
    };
  }, [mUserIds]);

  useEffect(() => {
    if (filterText.length > 0) {
      setMUserList(
        mUserList.filter(obj =>
          JSON.stringify(obj)
            .toLowerCase()
            .includes(filterText.toLowerCase())
        )
      );
    } else {
      setFilteredMUsers(mUserList);
    }
  }, [mUserList, filterText]);

  const processData = data => {
    data.docChanges().forEach(async change => {
      try {
        let CalibScore = null;
        let sign = "flat";
        let daysAgo =
          change.doc.data().LastSessionDoneAt &&
          getDaysAgo(
            change.doc
              .data()
              .LastSessionDoneAt.toDate()
              .toDateString()
          );
        let obj = {
          uid: change.doc.id,
          ...change.doc.data(),
          SessionDoneDaysAgo: daysAgo
        };
        // Standard deviation calcution start
        let prevCalibrationIds = change.doc.data().PrevCalibrationResult
          ? change.doc.data().PrevCalibrationResult
          : [];
        let calibrationIds = [];
        let calibrationData = [];
        let calibration10Ids = [];
        if (change.doc.data().CalibrateResult) {
          calibrationIds.push(change.doc.data().CalibrateResult.id);
        }
        if (prevCalibrationIds.length > 0) {
          for (let index = 0; index < prevCalibrationIds.length; index++) {
            const element = prevCalibrationIds[index];
            calibrationIds.push(element.id);
          }
        }
        const calibrationDocRef = collection(db, "CalibrateResult");
        for (let cc = 0; cc < calibrationIds.length; cc++) {
          if (calibration10Ids.length <= 10) {
            calibration10Ids.push(calibrationIds[cc]);
          }
          if (
            calibration10Ids.length === 10 ||
            cc === calibrationIds.length - 1
          ) {
            const docSnap = query(
              calibrationDocRef,
              where(documentId(), "in", calibration10Ids)
            );
            const calibrationDocs = await getDocs(docSnap);
            for (let cd = 0; cd < calibrationDocs.docs.length; cd++) {
              let avg = !isNotExists(
                calibrationDocs.docs[cd].data().RecordedDevice
              )
                ? calibrationDocs.docs[cd].data().CalibrationAvg
                : convertTomm(calibrationDocs.docs[cd].data().CalibrationAvg);
              let calibration5Data = calibrationDocs.docs[cd].data()
                .CalibrationData;
              let RecordedDeviceData = null;
              if (calibrationDocs.docs[cd].data().RecordedDevice) {
                const deviceData = await getDoc(
                  calibrationDocs.docs[cd].data().RecordedDevice
                );
                if (deviceData.exists()) {
                  RecordedDeviceData = deviceData.data();
                }
              }
              if (
                !isNotExists(calibrationDocs.docs[cd].data().RecordedDevice)
              ) {
                let c5Data = [];
                calibration5Data.forEach(item => {
                  c5Data.push(roundOffTwo(item));
                });
                calibration5Data = c5Data;
              }
              calibrationData.push({
                uid: calibrationDocs.docs[cd].id,
                ...calibrationDocs.docs[cd].data(),
                CalibrationAvg: avg,
                CalibrationData: calibration5Data,
                RecordedDeviceData
              });
              calibrationData.sort(function(a, b) {
                return (
                  new Date(b.CalibratedOnDate.toDate()) -
                  new Date(a.CalibratedOnDate.toDate())
                );
              });
            }
            calibration10Ids = [];
          }
        }
        let lastFiveCalibrationAvgs = [];
        if (calibrationData.length >= 5) {
          for (let p = 0; p < 5; p++) {
            lastFiveCalibrationAvgs.push(calibrationData[p].CalibrationAvg);
          }
        }
        let standardDeviationValue = "";
        let standardDeviationPercentage = "";
        if (lastFiveCalibrationAvgs.length === 5) {
          let { deviationValue, deviationPercentage } = standardDeviation(
            lastFiveCalibrationAvgs
          );
          standardDeviationValue = roundOffTwo(deviationValue);
          standardDeviationPercentage = roundOffTwo(deviationPercentage);
        }
        let CalibrationStandardDeviation = "";
        let CalibrationStandardDeviationPercentage = "";
        if (calibrationData.length > 0) {
          let { deviationValue, deviationPercentage } = standardDeviation(
            calibrationData[0].CalibrationData
          );
          CalibrationStandardDeviation = roundOffTwo(deviationValue);
          CalibrationStandardDeviationPercentage = roundOffTwo(
            deviationPercentage
          );
        }

        // dividing two calibs by calib score
        if (standardDeviationValue && CalibScore) {
          standardDeviationValue =
            Number(standardDeviationValue) / Number(CalibScore);
        }
        if (CalibrationStandardDeviation && CalibScore) {
          CalibrationStandardDeviation =
            Number(CalibrationStandardDeviation) / Number(CalibScore);
        }
        // end

        obj = {
          ...obj,
          StandardDeviation: standardDeviationValue,
          FirstSessionDoneOn:
            calibrationData.length > 0
              ? calibrationData[calibrationData.length - 1].CalibratedOnDate
              : "",
          StandardDeviationIcon:
            standardDeviationPercentage &&
            remoteConfigData &&
            remoteConfigData.Training_Standard_Deviation
              ? standardDeviationPercentage >
                remoteConfigData.Training_Standard_Deviation._value
                ? true
                : false
              : false,
          CalibrationStandardDeviation: CalibrationStandardDeviation,
          CalibrationStandardDeviationIcon:
            CalibrationStandardDeviationPercentage &&
            remoteConfigData &&
            remoteConfigData.Calibration_Standard_Deviation
              ? CalibrationStandardDeviationPercentage >
                remoteConfigData.Calibration_Standard_Deviation._value
                ? true
                : false
              : false
        };
        // Standard deviation calculation end
        // Any chnages made by user start
        obj = {
          ...obj,
          ChangesMade: detectChanges(obj)
        };
        // Any chnages made by user end
        if (change.type === "added") {
          if (change.doc.data().CalibrateResult) {
            let last_three = change.doc.data().PrevCalibrationResult.slice(-3);
            const docSnap = await getDoc(change.doc.data().CalibrateResult);
            if (docSnap.exists()) {
              CalibScore = roundOff(docSnap.data().CalibrationAvg);
            }
            if (CalibScore && last_three.length > 0) {
              const docRef = collection(db, "CalibrateResult");
              const docSnaps = query(
                docRef,
                where(documentId(), "in", last_three)
              );
              const ddd = await getDocs(docSnaps);
              let last_three_score = 0;
              ddd.forEach((a, index) => {
                last_three_score = last_three_score + a.data().CalibrationAvg;
              });
              last_three_score = last_three_score / 3;
              if (last_three_score > CalibScore) {
                sign = "down";
              } else if (last_three_score < CalibScore) {
                sign = "up";
              }
            }
          }
          setMUserList(prevUsers => [
            ...prevUsers,
            { ...obj, CalibScore, sign }
          ]);
        }
        if (change.type === "modified") {
          let newArray = [...mUserListRef.current];
          let index = newArray.findIndex(user => change.doc.id === user.uid);
          if (change.doc.data().CalibrateResult) {
            let last_three = change.doc.data().PrevCalibrationResult.slice(-3);
            const docSnap = await getDoc(change.doc.data().CalibrateResult);
            if (docSnap.exists()) {
              CalibScore = roundOff(docSnap.data().CalibrationAvg);
            }
            if (CalibScore && last_three.length > 0) {
              const docRef = collection(db, "CalibrateResult");
              const docSnaps = query(
                docRef,
                where(documentId(), "in", last_three)
              );
              const ddd = await getDocs(docSnaps);
              let last_three_score = 0;
              ddd.forEach((a, index) => {
                last_three_score = last_three_score + a.data().CalibrationAvg;
              });
              last_three_score = last_three_score / 3;
              if (last_three_score > CalibScore) {
                sign = "down";
              } else if (last_three_score < CalibScore) {
                sign = "up";
              }
            }
          }
          newArray[index] = { ...obj, CalibScore, sign };
          setMUserList(newArray);
        }
        if (change.type === "removed") {
          let newArray = [...mUserListRef.current];
          let index = newArray.findIndex(user => change.doc.id === user.uid);
          newArray.splice(index, 1);
          setMUserList(newArray);
        }
      } catch (error) {
        //do nothing
      }
    });
  };

  const columns = [
    {
      dataField: "FirstName",
      text: "Full Name",
      sort: true,
      formatter: (cell, row) => {
        return (
          <NavLink
            style={{
              color: "inherit",
              fontSize: "15px",
              fontWeight: 500,
              padding: 0,
              wordWrap: "break-word"
            }}
            tag={props => <RouteNavLink target={"_blank"} {...props} />}
            to={`/user-details/${row.uid}`}
          >
            {" "}
            {`${row.FirstName}`}
          </NavLink>
        );
      },
      style: {
        cursor: "pointer"
      }
    },
    {
      dataField: "Email",
      sort: true,
      text: "Email",
      style: {
        cursor: "pointer"
      },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          history.push(`/student-details/${row.uid}`);
        }
      }
    },
    // {
    //   dataField: 'RegisteredOn',
    //   text: 'Registered At',
    //   sort: true,
    //   formatter: (cell, row) => {
    //     return <>{cell ?
    //       cell.toDate().toDateString() : '-'}</>
    //   }
    // },
    {
      dataField: "ValidTill",
      text: "Valid Till",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? cell.toDate().toDateString() : "-"}</>;
      }
    },
    {
      dataField: "DeviceInfo.version",
      text: "App Version",
      sort: true,
      formatter: (cell, row) => {
        return <>{cell ? cell : "-"}</>;
      }
    },
    // {
    //   dataField: 'LastSessionDoneAt',
    //   sort: true,
    //   text: 'Last Session Done At',
    //   formatter: (cell, row) => {
    //     return cell ?
    //       moment(
    //         cell.toDate().toString()
    //       ).format("lll") : '-'
    //   }
    // },
    {
      dataField: "CalibScore",
      sort: true,
      text: "Calibration Score",
      formatter: (cell, row) => {
        return (
          <>
            {cell ? (
              <>
                <span>{cell}</span>
                {row.sign === "up" ? (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    arrow_upward
                  </i>
                ) : row.sign === "down" ? (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    arrow_downward
                  </i>
                ) : (
                  <i className="material-icons" style={{ cursor: "pointer" }}>
                    horizontal_rule
                  </i>
                )}
              </>
            ) : (
              "-"
            )}
          </>
        );
      }
    },
    {
      dataField: "LastSessionDoneAt",
      text: "Time Since the Last Session",
      sort: true,
      formatter: (cell, row) => {
        return (
          <span
            style={{
              color: checkDateForColorView(
                row.LastSessionDoneAt &&
                  row.LastSessionDoneAt.toDate().toDateString()
              )
            }}
          >
            {row.LastSessionDoneAt &&
              getDaysAgo(row.LastSessionDoneAt.toDate().toDateString())
            // moment(
            //   row.LastSessionDoneAt.toDate().toString()
            // ).fromNow()
            }
          </span>
        );
      }
    }
  ];

  const getDaysAgo = date => {
    let currentDate = moment.now();
    let dateInDB = moment(date);
    let result = dateInDB.diff(currentDate, "days");
    if (result < 0) {
      return `${-result} days ago`;
    } else {
      return `${result} days ago`;
    }
  };

  const pagination = paginationFactory({
    sizePerPage: 50,
    hideSizePerPage: true
  });

  const checkDateForColorView = date => {
    if (date) {
      let currentDate = moment();
      let checkingDate = moment(date);
      let result = currentDate.diff(checkingDate, "days");
      if (result >= 7) {
        return "red";
      } else if (result <= 6 && result >= 3) {
        return "purple";
      } else if (result >= 1 && result <= 2) {
        return "orange";
      } else {
        return "green";
      }
    } else {
      return "black";
    }
  };

  const searchBar = () => {
    return (
      <input
        className="form-control"
        type="text"
        placeholder="Search in table"
        value={filterText}
        onChange={e => {
          // props.onSearch(e.target.value);
          setFilterText(e.target.value);
        }}
      />
    );
  };

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      {loading ? (
        <div className="wrapper">
          <div className="spinner">
            <div className="spinner-1"></div>
            <div className="spinner-2"></div>
            <div className="spinner-3"></div>
          </div>
        </div>
      ) : (
        <Row className="page-header py-4">
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-4 pb-3">
                <ToolkitProvider
                  keyField="uid"
                  data={filteredMUsers}
                  columns={columns}
                  bootstrap4
                  search
                >
                  {props => (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "15px 0px"
                        }}
                      >
                        <h6 className="m-0 font-weight-bold">Students List</h6>
                        <div className="w-60">{searchBar()}</div>
                      </div>
                      <BootstrapTable
                        pagination={pagination}
                        {...props.baseProps}
                      />
                    </div>
                  )}
                </ToolkitProvider>
                {/* <BootstrapTable keyField='uid' data={Users} columns={columns} pagination={pagination} rowEvents={rowEvents} bootstrap4 /> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default MonitoringUsers;
